const SELECTED_CLASS_STORAGE_KEY = 'selectedClassCrCode';

export default function withSelectedClassCode(body) {
  const classCode = localStorage.getItem(SELECTED_CLASS_STORAGE_KEY);
  if (!classCode) return body;
  return { ...body, classCode };
}
